<template>
  <div>
    <el-form
      v-if="false"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="160px"
      class="demo-ruleForm"
    >
      <el-form-item label="企业名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          size="small"
          class="inpyabeb"
          placeholder="请输入企业名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="企业地址" prop="address">
        <el-input
          v-model="ruleForm.address"
          size="small"
          class="inpyabeb"
          placeholder="请输入企业地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contact_number">
        <el-input
          v-model="ruleForm.contact_number"
          size="small"
          class="inpyabeb"
          placeholder="请输入联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="unified_social_credit_code">
        <el-input
          v-model="ruleForm.unified_social_credit_code"
          size="small"
          class="inpyabeb"
          placeholder="请输入统一社会信用代码"
        ></el-input>
      </el-form-item>
      <el-form-item label="企业性质" prop="enterprise_nature">
        <el-select
          v-model="ruleForm.enterprise_nature"
          placeholder="请选择企业性质"
          class="inpyabeb"
          size="small"
        >
          <el-option label="事业单位" value="事业单位"></el-option>
          <el-option label="国有企业" value="国有企业"></el-option>
          <el-option label="私营企业" value="私营企业"></el-option>
          <el-option label="中央企业" value="中央企业"></el-option>
          <el-option label="外商独资企业" value="外商独资企业"></el-option>
          <el-option label="中外合资企业" value="中外合资企业"></el-option>
          <el-option
            label="境外非政府组织的境内代表机构"
            value="境外非政府组织的境内代表机构"
          ></el-option>
          <el-option label="个体工商户" value="个体工商户"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经济类型" prop="economic_type">
        <el-select
          v-model="ruleForm.economic_type"
          placeholder="请选择经济类型"
          class="inpyabeb"
          size="small"
        >
          <el-option label="国有经济" value="国有经济"></el-option>
          <el-option label="集体经济" value="集体经济"></el-option>
          <el-option label="私营经济" value="私营经济"></el-option>
          <el-option label="个体经济" value="个体经济"></el-option>
          <el-option label="联营经济" value="联营经济"></el-option>
          <el-option label="股份制" value="股份制"></el-option>
          <el-option label="外商投资" value="外商投资"></el-option>
          <el-option label="港澳台投资" value="港澳台投资"></el-option>
          <el-option label="其他经济类" value="其他经济类"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否上市" prop="is_list">
        <el-radio-group
          v-model="ruleForm.is_list"
          size="small"
          class="inpyabeb"
        >
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="成立时间" required>
        <el-form-item prop="established_time" size="small">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            v-model="ruleForm.established_time"
            class="inpyabeb"
          ></el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item label="注册资本/万" prop="registered_capital">
        <el-input
          v-model="ruleForm.registered_capital"
          size="small"
          class="inpyabeb"
        ></el-input>
      </el-form-item>
      <el-form-item label="法定代表人" prop="legal_representative">
        <el-input
          v-model="ruleForm.legal_representative"
          size="small"
          class="inpyabeb"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0"
        label="法人身份证号"
        prop="legal_representative_id"
      >
        <el-input
          v-model="ruleForm.legal_representative_id"
          size="small"
          class="inpyabeb"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0"
        label="法定代表人或指定代表手机号码"
        prop="other_phone"
      >
        <el-input
          v-model="ruleForm.other_phone"
          size="small"
          class="inpyabeb"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0"
        label="本组织现任职务（按最高职务）"
        prop="job"
      >
        <el-select
          v-model="ruleForm.job"
          placeholder="请选择本组织现任职务（按最高职务）"
          class="inpyabeb"
          size="small"
        >
          <el-option label="无" value="wu"></el-option>
          <el-option label="副会长" value="fuhuizhang"></el-option>
          <el-option label="常务理事" value="changwulishi"></el-option>
          <el-option label="理事" value="lishi"></el-option>
          <el-option label="一般会员" value="yibanhuiyuan"></el-option>
          <el-option label="监事长" value="jianshizhang"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0"
        label="是否任本组织秘书长"
        prop="is_secretary_general"
      >
        <el-radio-group
          v-model="ruleForm.is_secretary_general"
          size="small"
          class="inpyabeb"
        >
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0"
        label="是否任本组织法定代表人"
        prop="is_representative"
      >
        <el-radio-group
          v-model="ruleForm.is_representative"
          size="small"
          class="inpyabeb"
        >
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0 && member.level != 1"
        label="政治面貌"
        prop="political_outlook"
      >
        <el-select
          v-model="ruleForm.political_outlook"
          placeholder="政治面貌"
          class="inpyabeb"
          size="small"
        >
          <el-option label="群众" value="qunhzong"></el-option>
          <el-option label="中国共产党党员" value="dangyuan"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.political_outlook == 'dangyuan'"
        label="本组织党内职务"
        prop="party_posts"
      >
        <el-select
          v-model="ruleForm.party_posts"
          placeholder="请选择党内职务"
          class="inpyabeb"
          size="small"
        >
          <el-option label="无" value="wu"></el-option>
          <el-option label="副会长" value="fuhuizhang"></el-option>
          <el-option label="常务理事" value="changwulishi"></el-option>
          <el-option label="理事" value="lishi"></el-option>
          <el-option label="一般会员" value="yibanhuiyuan"></el-option>
          <el-option label="监事长" value="jianshizhang"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.political_outlook == 'dangyuan'"
        label="党组织关系所在单位"
        prop="company"
      >
        <el-input
          v-model="ruleForm.company"
          size="small"
          class="inpyabeb"
          placeholder="请输入党组织关系所在单位..."
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0 && member.level != 1"
        label="文化程度"
        prop="education_degree"
      >
        <el-select
          v-model="ruleForm.education_degree"
          placeholder="文化程度"
          class="inpyabeb"
          size="small"
        >
          <el-option label="小学" value="xiaoxue"></el-option>
          <el-option label="初中" value="chuzhong"></el-option>
          <el-option label="高中" value="gaozhong"></el-option>
          <el-option label="大专" value="dazhuan"></el-option>
          <el-option label="本科" value="benke"></el-option>
          <el-option label="硕士" value="suoshi"></el-option>
          <el-option label="博士" value="boshi"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0 && member.level != 1"
        label="是否社工师"
        prop="is_social_worker"
      >
        <el-radio-group
          v-model="ruleForm.is_social_worker"
          size="small"
          class="inpyabeb"
        >
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0 && member.level != 1"
        label="职业资格水平"
        prop="professional_qualification_level"
      >
        <el-select
          v-model="ruleForm.professional_qualification_level"
          placeholder="职业资格水平"
          class="inpyabeb"
          size="small"
        >
          <el-option label="教授级高工" value="xiaoxue"></el-option>
          <el-option label="高级工程师" value="chuzhong"></el-option>
          <el-option label="中级工程师" value="gaozhong"></el-option>
          <el-option label="初级工程师" value="benke"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="member.level != 0 && member.level != 1"
        label="是否本组织从业人员"
        prop="is_employees"
      >
        <el-radio-group
          v-model="ruleForm.is_employees"
          size="small"
          class="inpyabeb"
        >
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="营业执照" prop="business_license">
        <el-upload
          ref="upload"
          :action="$baseURL + '/api/home/upload/file/user'"
          accept=".jpg, .png"
          :data="{ token: token }"
          :file-list="fileList"
          :limit="limit"
          list-type="picture-card"
          :on-exceed="handleExceed"
          :on-success="handleAdd"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <!-- <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
								<i class="el-icon-download"></i>
              </span>-->
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
      <el-form-item label="基本介绍" prop="introduce">
        <el-input
          type="textarea"
          placeholder="请输入单位的基本介绍文字..."
          :autosize="{ minRows: 8, maxRows: 1600 }"
          v-model="ruleForm.introduce"
          size="small"
          class="inpyabeb"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否展示" prop="is_show">
        <el-radio-group
          v-model="ruleForm.is_show"
          size="small"
          class="inpyabeb"
        >
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="block-solid"></div>
      <el-form-item style="margin-left: 200px">
        <el-button
          type="primary"
          icon="el-icon-check"
          style="background-color: #194abe"
          @click="submitForm('ruleForm')"
          class="block-submit"
          >保存修改</el-button
        >
      </el-form-item>
    </el-form>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-tabs
        style="margin-top: 16px"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="单位信息" name="first">
          <div class="my_form">
            <div class="form_title" style="height: 62px">企业名称</div>
            <div class="form_long">
              <input
                placeholder="请输入"
                type="text"
                v-model="ruleForm.enterprise_name"
              />
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 62px">企业地址</div>
            <div class="form_long">
              <input
                placeholder="请输入"
                type="text"
                v-model="ruleForm.address"
              />
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 62px">统一社会信用代码</div>
            <div class="form_long">
              <input
                placeholder="请输入"
                type="text"
                v-model="ruleForm.unified_social_credit_code"
              />
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">法定代表人</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.legal_representative"
                  />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">法人身份证号</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.legal_representative_id"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">企业性质</div>
              <div class="form_content">
                <el-select
                  v-model="ruleForm.enterprise_nature"
                  placeholder="请选择企业性质"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="事业单位" value="事业单位"></el-option>
                  <el-option label="国有企业" value="国有企业"></el-option>
                  <el-option label="私营企业" value="私营企业"></el-option>
                  <el-option label="中央企业" value="中央企业"></el-option>
                  <el-option
                    label="外商独资企业"
                    value="外商独资企业"
                  ></el-option>
                  <el-option
                    label="中外合资企业"
                    value="中外合资企业"
                  ></el-option>
                  <el-option
                    label="境外非政府组织的境内代表机构"
                    value="境外非政府组织的境内代表机构"
                  ></el-option>
                  <el-option label="个体工商户" value="个体工商户"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">经济类型</div>
              <div class="form_content">
                <el-select
                  v-model="ruleForm.economic_type"
                  placeholder="请选择企业性质"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="国有经济" value="国有经济"></el-option>
                  <el-option label="集体经济" value="集体经济"></el-option>
                  <el-option label="私营经济" value="私营经济"></el-option>
                  <el-option label="个体经济" value="个体经济"></el-option>
                  <el-option label="联营经济" value="联营经济"></el-option>
                  <el-option label="股份制" value="股份制"></el-option>
                  <el-option label="外商投资" value="外商投资"></el-option>
                  <el-option label="港澳台投资" value="港澳台投资"></el-option>
                  <el-option label="其他经济类" value="其他经济类"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">是否上市</div>
              <div class="form_content">
                <el-radio-group
                  v-model="islist"
                  size="small"
                  class="inpyabeb"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">成立时间</div>
              <div class="form_content">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  placeholder="选择日期"
                  v-model="ruleForm.established_time"
                  class="inpyabeb"
                ></el-date-picker>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">注册资本</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.registered_capital"
                  />
                  <span>万</span>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">联系电话</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.contact_number"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">是/否施工企业</div>
              <div class="form_content">
                <div class="form_content">
                <el-radio-group
                  v-model="ruleForm.is_construction_enterprises"
                  size="small"
                  class="inpyabeb"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">是/否省外企业</div>
              <div class="form_content">
                <div class="form_content">
                <el-radio-group
                  v-model="ruleForm.is_outside_enterprises"
                  size="small"
                  class="inpyabeb"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">主项资质类别</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.main_qualification_category"
                  />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">主项资质等级</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.main_item_qualification_level"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">联系人QQ</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.qq"
                  />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">入黔企业分公司名称（省外企业必填）</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.name_of_branch_of_enterprise_entering_guizhou"
                  />
                </div>
              </div>
            </div>
          </div>
           <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">在黔机构负责人姓名（省外企业必填）</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.name_of_the_person_in_charge_of_the_organization_in_guizhou"
                  />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">隶属关系（省外企业必填）</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.subordination"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 110px">营业执照</div>
              <el-upload
                style="height: 110px"
                class="upload-demo"
                :action="$baseURL + '/api/home/upload/file/user'"
                :limit="limit"
                accept=".jpg, .png"
                :data="{ token: token }"
                :on-exceed="handleExceed"
                :on-success="handleAdd"
                :on-remove="handleRemove"
                :file-list="fileList"
                list-type="picture"
              >
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  style="margin-right: 10px"
                  >选择文件</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="fileList.length < 1"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 110px">上传资质证书</div>
              <el-upload
                style="height: 110px"
                class="upload-demo"
                :action="$baseURL + '/api/home/upload/file/user'"
                :limit="limit"
                accept=".jpg, .png"
                :data="{ token: token }"
                :on-exceed="handleExceed"
                :on-success="handleAdd2"
                :on-remove="handleRemove2"
                :file-list="fileList2"
                list-type="picture"
              >
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  style="margin-right: 10px"
                  >选择文件</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="fileList2.length < 1"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px">基本介绍</div>
            <div class="form_textarea">
              <textarea
                name
                id
                cols="30"
                rows="10"
                placeholder="请输入"
                v-model="ruleForm.introduce"
              ></textarea>
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 62px">
              是否需要在协会官网上展示
            </div>
            <div style="height: 62px; line-height: 62px; margin-left: 10px">
              <el-switch
                v-model="ruleForm.is_show"
                active-text="允许游客查看我公司基础信息和项目"
              >
              </el-switch>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="联系人信息" name="second">
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">姓名</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.contact_user_name"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">工作部门</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.contact_work_department"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">职务</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.contact_post"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">固定电话</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.contact_fixed_telephone"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">移动电话</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.contact_mobile_phone"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="法人信息" name="third">
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">社会组织名称</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    disabled="disabled"
                    value="贵州省建筑业协会"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                统一社会信用代码
              </div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    disabled="disabled"
                    value="51520000517556837W"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                单位法定代表人或指定代表人手机号码
              </div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.other_phone"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                本组织现任职务（按最高职务）
              </div>
              <div class="form_content">
                <el-select
                  v-model="ruleForm.job"
                  placeholder="请选择本组织现任职务"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="无" value="无"></el-option>
                  <el-option label="副会长" value="副会长"></el-option>
                  <el-option label="常务理事" value="常务理事"></el-option>
                  <el-option label="理事" value="理事"></el-option>
                  <el-option label="一般会员" value="一般会员"></el-option>
                  <el-option label="监事长" value="监事长"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                增加单位法定代表人或指定代表人
              </div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.company_legal_representative"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                增加单位法定代表人或指定代表人手机号码
              </div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.company_other_phone"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                单位法定代表人或指定代表人是否为本组织从业人员
              </div>
              <div class="form_content">
                <el-radio-group
                  v-model="ruleForm.is_employees"
                  size="small"
                  class="inpyabeb"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                是否任本组织秘书长
              </div>
              <div class="form_content">
                <el-radio-group
                  v-model="ruleForm.is_secretary_general"
                  size="small"
                  class="inpyabeb"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                是否任本组织法定代表人
              </div>
              <div class="form_content">
                <el-radio-group
                  v-model="ruleForm.is_representative"
                  size="small"
                  class="inpyabeb"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                单位法定代表人或指定代表人政治面貌
              </div>
              <div class="form_content">
                <el-select
                  v-model="ruleForm.political_outlook"
                  placeholder="请选择代表人政治面貌"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="普通居民" value="普通居民"></el-option>
                  <el-option
                    label="中国共产党党员"
                    value="中国共产党党员"
                  ></el-option>
                  <el-option
                    label="中国共产党预备党员"
                    value="中国共产党预备党员"
                  ></el-option>
                  <el-option
                    label="中国共产主义青年团团员"
                    value="中国共产主义青年团团员"
                  ></el-option>
                  <el-option
                    label="中国国民党革命委员会会员"
                    value="中国国民党革命委员会会员"
                  ></el-option>
                  <el-option
                    label="中国民主同盟盟员"
                    value="中国民主同盟盟员"
                  ></el-option>
                  <el-option
                    label="中国民主建国会会员"
                    value="中国民主建国会会员"
                  ></el-option>
                  <el-option
                    label="中国民主促进会会员"
                    value="中国民主促进会会员"
                  ></el-option>
                  <el-option
                    label="中国农工民主党党员"
                    value="中国农工民主党党员"
                  ></el-option>
                  <el-option
                    label="中国致公党党员"
                    value="中国致公党党员"
                  ></el-option>
                  <el-option
                    label="九三学社社员"
                    value="九三学社社员"
                  ></el-option>
                  <el-option
                    label="台湾民主自治同盟盟员"
                    value="台湾民主自治同盟盟员"
                  ></el-option>
                  <el-option
                    label="无党派民主人士"
                    value="无党派民主人士"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="flex" v-if="ruleForm.political_outlook != '普通居民'">
            <div class="my_form">
              <div class="form_title" style="height: 62px">本组织党内职务</div>
              <div class="form_content">
                <el-select
                  v-model="ruleForm.party_posts"
                  placeholder="请选择本组织党内职务"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="无" value="无"></el-option>
                  <el-option label="党支部书记" value="党支部书记"></el-option>
                  <el-option
                    label="党支部副书记"
                    value="党支部副书记"
                  ></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                党组织关系所在单位
              </div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.company"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                单位法定代表人或指定代表人文化程度
              </div>
              <div class="form_content">
                <el-select
                  v-model="ruleForm.education_degree"
                  placeholder="请选择代表人文化程度"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="博士后" value="博士后"></el-option>
                  <el-option label="博士研究生" value="博士研究生"></el-option>
                  <el-option label="硕士研究生" value="硕士研究生"></el-option>
                  <el-option label="大学本科" value="大学本科"></el-option>
                  <el-option label="大专" value="大专"></el-option>
                  <el-option label="高中及以下" value="高中及以下"></el-option>
                </el-select>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                单位法定代表人或指定代表人是否社工师
              </div>
              <div class="form_content">
                <el-radio-group
                  v-model="ruleForm.is_social_worker"
                  size="small"
                  class="inpyabeb"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                单位法定代表人或指定代表人职业资格水平
              </div>
              <div class="form_content">
                <el-select
                  v-model="ruleForm.professional_qualification_level"
                  placeholder="请选择职业资格水平"
                  class="inpyabeb"
                  size="small"
                >
                  <el-option label="无" value="无"></el-option>
                  <el-option label="高级职称" value="高级职称"></el-option>
                  <el-option label="副高级职称" value="副高级职称"></el-option>
                  <el-option label="中级职称" value="中级职称"></el-option>
                  <el-option label="初级职称" value="初级职称"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="企业logo" name="fourth">
          <div class="my_form">
            <div class="form_title" style="height: 188px">企业logo</div>
            <div class="form_long">
              <el-upload
                ref="upload"
                :action="$baseURL + '/api/home/upload/file/user'"
                accept=".jpg, .png"
                :data="{ token: token }"
                :file-list="head_portrait"
                :limit="limit"
                list-type="picture-card"
                :on-exceed="handleExceed"
                :on-success="handleAddhead_portrait"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <!-- <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>-->
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="head_portraitremove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </div>

            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-tab-pane>
        <el-tab-pane label="票据信息" name="Billinfo">
          <div class="my_form">
            <div class="form_title" style="height: 62px">交款人单位名称</div>
            <div class="form_long">
              <input
                placeholder="请输入"
                v-model="ruleForm.bill_unit_name"
                type="text"
              />
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 62px">统一社会信用代码</div>
            <div class="form_long">
              <input
                placeholder="请输入"
                v-model="ruleForm.bill_unified_social_credit_code"
                type="text"
              />
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">手机号</div>
              <div class="form_content">
                <div class="input">
                  <input
                    type="text"
                    v-model="ruleForm.bill_phone"
                    placeholder="请输入"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div class="bot-red-border">
      <div class="btn-give_up" @click="give_up">放弃修改</div>
      <div class="btn-modify" @click="submitForm('ruleForm')">
        <img src="@/assets/19178@2x.png" alt="" />
        <p>保存修改</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetMember, //获取用户信息
  UpdataMember, //更新用户信息
} from "../../utils/api.js";
export default {
  name: "CompanInfo",
  components: {},
  props: {
    member: {
      type: Object,
      default: function () {
        return;
      },
    },
  },
  // props:['member'],
  data() {
    return {
      established_time: "",
      enterprise_nature: "",
      Basicsinfo: {},
      value1: 1,
      Businesslicense: [],
      islist: "0",
      Enterprisename: "",
      activeName: "first",
      limit: 1,
      token: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      ruleForm: {
        name: "",
        contact_number: "",
        unified_social_credit_code: "",
        enterprise_nature: "",
        economic_type: "",
        is_list: 0,
        established_time: "",
        registered_capital: "",
        legal_representative: "",
        legal_representative_id: "", //法定身份证号
        // Social_name:'',//社会组织名称
        other_phone: "", //法人电话
        job: "", //本组织现任职务
        is_secretary_general: "", //是否秘书长
        is_representative: "", //是否法定代表人
        political_outlook: "", //政治面貌
        education_degree: "", //文化程度
        is_social_worker: "", //是否社工师
        is_employees: "", //是否本组织从业人员
        professional_qualification_level: "", //职业资格水平
        business_license: "",
        is_show: "",
        party_posts: "", //本组织党内职务
        company: "", //党组织关系所在单位
        introduce: "", //基本介绍
        head_portrait: "", //企业标识图
        certifications:"",//上传资质证书
        address: "", //企业地址
      },
      fileList: [],
      fileList2:[],
      head_portrait: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur",
          },
        ],
        introduce: [
          {
            required: true,
            message: "请输入单位的基本介绍文字...",
            trigger: "change",
          },
        ],
        party_posts: [
          {
            required: true,
            message: "请选择本组织党内职务",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            message: "请输入党组织关系所在单位",
            trigger: "change",
          },
        ],
        professional_qualification_level: [
          {
            required: true,
            message: "请选择职业资格水平",
            trigger: "change",
          },
        ],
        is_employees: [
          {
            required: true,
            message: "是否本组织从业人员",
            trigger: "change",
          },
        ],
        is_social_worker: [
          {
            required: true,
            message: "是否社工师",
            trigger: "change",
          },
        ],
        political_outlook: [
          {
            required: true,
            message: "请选择政治面貌",
            trigger: "change",
          },
        ],
        education_degree: [
          {
            required: true,
            message: "请选择文化程度",
            trigger: "change",
          },
        ],
        contact_number: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change",
          },
        ],
        unified_social_credit_code: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
        ],
        enterprise_nature: [
          {
            required: true,
            message: "请选择企业性质",
            trigger: "change",
          },
        ],
        economic_type: [
          {
            required: true,
            message: "请选择经济类型",
            trigger: "change",
          },
        ],
        is_list: [
          {
            required: true,
            message: "请选择是否上市",
            trigger: "change",
          },
        ],
        established_time: [
          {
            type: "string",
            required: true,
            message: "请选择成立日期",
            trigger: "change",
          },
        ],
        registered_capital: [
          {
            required: true,
            message: "请输入注册资本/万",
            trigger: "change",
          },
        ],
        legal_representative: [
          {
            // type: 'array',
            required: true,
            message: "请输入发定代表人",
            trigger: "change",
          },
        ],
        legal_representative_id: [
          {
            required: true,
            message: "请输入法人身份证",
            trigger: "change",
          },
        ],
        // Social_name:[{
        // 	required: true,
        // 	message: '请输入社会组织名称',
        // 	trigger: 'change'
        // }],
        other_phone: [
          {
            required: true,
            message: "请输入法定代表人或指定代表手机号码",
            trigger: "change",
          },
        ],
        job: [
          {
            required: true,
            message: "请选择本组织现任职务（按最高职务）",
            trigger: "change",
          },
        ],
        is_secretary_general: [
          {
            required: true,
            message: "是否任本组织秘书长",
            trigger: "change",
          },
        ],
        is_representative: [
          {
            required: true,
            message: "是否任本组织法定代表人",
            trigger: "change",
          },
        ],
        business_license: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "change",
          },
        ],
        is_show: [
          {
            required: true,
            message: "请选择是否展示",
            trigger: "change",
          },
        ],
      },
    };
  },
  async created() {
    this.ruleForm = await GetMember();
    delete this.ruleForm.updated_at;
    delete this.ruleForm.created_at;
    if (this.ruleForm.head_portrait == null) {
      this.head_portrait = [];
    } else {
      this.head_portrait = [
        {
          name: "aaa",
          url: this.ruleForm.head_portrait,
        },
      ];
    }
    if (this.ruleForm.business_license == null) {
      this.fileList = [];
    } else {
      this.fileList = [
        {
          name: "aaa",
          url: this.ruleForm.business_license,
        },
      ];
    }
    if (this.ruleForm.certifications == null) {
      this.fileList2 = [];
    } else {
      this.fileList2 = [
        {
          name: "aaa",
          url: this.ruleForm.certifications,
        },
      ];
    }
    
    if(this.ruleForm.is_list) {
      this.islist = this.ruleForm.is_list.toString()
      this.ruleForm.is_show = this.ruleForm.is_show == "1" ? true : false
    };
    
    this.ruleForm.is_construction_enterprises =
      this.ruleForm.is_construction_enterprises?.toString();
    this.ruleForm.is_outside_enterprises =
      this.ruleForm.is_outside_enterprises?.toString();
    this.ruleForm.is_secretary_general =
      this.ruleForm.is_secretary_general?.toString();
    this.ruleForm.is_representative =
      this.ruleForm.is_representative?.toString();
    this.ruleForm.is_social_worker = this.ruleForm.is_social_worker?.toString();
    this.ruleForm.is_employees = this.ruleForm.is_employees?.toString();
    this.token = "Bearer " + localStorage.getItem("TOKEN");
  },

  methods: {
    give_up() {
      //放弃修改
      this.$emit("isCompanInfo", false);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handlesuccess2(file, fileList) {
      console.log(file, fileList);
      this.Businesslicense = [fileList];
    },
    handlePreview2(file) {},
    submitForm(formName) {
      this.ruleForm.is_list = this.islist
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.ruleForm.is_show = this.ruleForm.is_show==true?'1':'0'
		// console.log(this.ruleForm);
		// return false;
          UpdataMember(this.ruleForm)
            .then((res) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              // setTimeout(() => {
              //   location.reload();
              // }, 500);
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAdd(response, file, fileList) {
      this.fileList = fileList;
      this.ruleForm.business_license = response.data.host + response.data.url;
    },
    handleAdd2(response, file, fileList){
      this.fileList2 = fileList;
      this.ruleForm.certifications = response.data.host + response.data.url;
    },
    handleAddhead_portrait(response, file, fileList) {
      this.head_portrait = fileList;
      this.ruleForm.head_portrait = response.data.host + response.data.url;
    },
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.business_license = "";
    },
    handleRemove2(){
      this.fileList2 = [];
      this.ruleForm.certifications = "";
    },
    head_portraitremove(file) {
      console.log(file);
      this.head_portrait = [];
      this.ruleForm.head_portrait = "";
    },
    handlePictureCardPreview(file) {
      console.log("ok");
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    handleExceed() {
      this.$message.warning(`请最多上传 ${this.limit} 个文件。`);
    },
  },
};
</script>
<style lang="less">
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
  .el-tabs__item,
  .is-active {
    color: #7c828a;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }
  .el-tabs__item.is-active {
    color: #194abe;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }
  .el-tabs__item:hover {
    color: #194abe;
  }
  .el-tabs__active-bar {
    background-color: #194abe;
  }
}
.el-form-item__error {
  margin-left: 140px;
}
.el-form-item__label {
  min-width: 300px;
}
.el-form-item__content {
  text-align: left;
}

.block-solid {
  margin-top: 70px;
}
</style>
<style scoped lang="less">
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bot-red-border {
  width: 100%;
  border-top: 2px solid #e51725;
  display: flex;
  justify-content: center;
  padding-top: 37px;
  margin-top: 40px;
  .btn-give_up {
    cursor: pointer;
    width: 189px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #194abe;
  }
  .btn-modify {
    cursor: pointer;
    width: 189px;
    height: 50px;
    background: #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
      height: 14px;
      margin-right: 10px;
    }
    p {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 27px;
      color: #ffffff;
    }
  }
}
.demo-ruleForm {
  width: 100%;
  margin: 30px 0;
  text-align: center;
  .inpyabeb {
    width: 50%;
  }
}
.my_form,
.my_form2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  align-items: stretch;
  .form_title {
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 0 6px;
    box-sizing: border-box;
    color: #0c0d0f;
  }
  .uploadinput {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .uploadlist {
      display: flex;
      align-items: center;
      margin: 10px 0;
    }
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 20px;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_content,
  .form_long,
  .form_choice {
    width: 300px;
    padding: 0px 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_choice_long {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 729px;
    padding-left: 20px;
    box-sizing: border-box;
    background: #f5f8fb;
  }
  .form_long {
    width: 729px;
    input {
      width: 688px;
    }
    div{
      display: flex;
      align-items: center;
      /deep/.el-upload-list{
        margin: 0 !important;
      }
    }
  }
  .form_textarea {
    width: 729px;
    height: 188px;
    display: flex;
    background: #f5f8fb;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 20px;
    textarea {
      width: 688px;
      height: 127px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 9px 15px;
      box-sizing: border-box;
      color: #000;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
  }
  .uploadimg {
    width: 729px;
    padding: 20px;
    background: #f5f8fb;
    box-sizing: border-box;
  }
  .Downinpustyle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background: #f5f8fb;
    .nejje {
      color: #194abe !important;
    }
  }
  .upload-demo {
    width: 729px;
    padding-left: 20px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 100px;
    .el-upload__tip {
      margin-left: 10px;
    }
  }
}
.my_form {
}
.my_form2 {
  .form_title {
    background: #f5f8fb;
  }
  .form_content,
  .form_long,
  .form_textarea,
  .form_choice,
  .form_choice_long,
  .upload-demo,
  .Downinpustyle {
    background: #fbfdff;
  }
}
</style>
